import { EntityClient } from "../../entity/EntityClient";

export class DtoClientsDeleteRes extends EntityClient {
  public message: string | null = null;
}
